export const EVENT_STRINGS = {
    // No client - legacy not to break old data
    LOBBY_FROM_PBX: 'User entered lobby',
    COPY_FROM_PBX: 'User copied link',
    JOINED_FROM_CHAT: 'User joined from chat',

    // New events, append client
    LOGGED_IN_CUSTOMER_LOADED: '[Telavox App] Logged in customer loaded',
    COPY_FROM_LOBBY: '[Telavox App] User copied link from lobby',
    CLICKED_LOBBY_ITEM: '[Telavox App] User clicked conference lobby item',
    JOINED_FROM_LOBBY: '[Telavox App] User joined conference from lobby',
    REQUEST_PIN_FROM_LOBBY: '[Telavox App] User requested pin from lobby',
    SEND_INFO_FROM_LOBBY:
        '[Telavox App] User clicked send info as email from lobby',
    LOGGED_IN_FROM_TEAMS_REGULAR_VERSION:
        '[Telavox App] User logged into the app from Teams Regular Version',
    LOGGED_IN_FROM_TEAMS_FULL_VERSION:
        '[Telavox App] User logged into the app from Teams Full Version',

    USED_OLD_VIDEO: '[Telavox App] User used old video chat',

    USER_JOINED_ROOM: 'VidCo user joined conference room',

    // Multiple/waiting calls
    USER_TOGGLED_CALL_WAITING: '[Call waiting] User toggled call waiting',
    USER_GOT_ANOTHER_CALL: '[Call waiting] User on a call got another call',
    USER_ACCEPTED_SECOND_CALL:
        '[Call waiting] User answered second call while in another call',
    USER_DECLINED_SECOND_CALL:
        '[Call waiting] User declined second call while in another call',
    USER_SWAPPED_CALLS: '[Call waiting] User swapped between two calls',
};

export const TICKET_STRINGS = {
    USER_BEGAN_WRITING_INTERNAL_NOTE:
        '[Tickets] User began writing an internal note',
    INTERNAL_NOTE_PUBLISHED: '[Tickets] Internal note was published',
    WHATSAPP_MESSAGE_PUBLISHED: '[Tickets] WhatsApp message published',
    SMS_MESSAGE_PUBLISHED: '[Tickets] SMS message published',
    EMAIL_MESSAGE_PUBLISHED: '[Tickets] Email message published',
    USER_ASSIGNED_TICKET:
        '[Tickets] User assigned the ticket to somebody (including self)',
    NEEDS_ATTENTION: '[Tickets] User clicked needs attention toggle',
    ASSIGNED_TO_ME: '[Tickets] User assigned to them self',
    USER_CHANGED_STATUS: '[Tickets] User changed ticket status',
    USER_BEGAN_WRITING_EMAIL_REPLY:
        '[Tickets] User began writing an email reply',
    USER_BEGAN_WRITING_TEXT_MESSAGE_REPLY:
        '[Tickets] User began writing a text message reply',
    USER_BEGAN_WRITING_WHATSAPP_REPLY:
        '[Tickets] User began writing a WhatsApp reply',
    USER_SENT_TEXT_MESSAGE: '[Tickets] User did send the text message',
    USER_SENT_INTERNAL_NOTE: '[Tickets] User did send internal note',
    USER_CHANGED_REPLY_CHANNEL: '[Tickets] User changed reply channel to',
    USER_ADDED_MEMBER_TO_TICKET:
        '[Tickets] User added a new member to the active ticket',
    USER_MENTIONED_COLLEAGUE: '[Tickets] User added mention in input field',
    USER_OPENED_RELATED_TICKETS_TAB:
        '[Tickets] User opened the Related Tickets tab',
    USER_OPENED_RELATED_TICKETS: '[Tickets] User clicked: tab Related',
    USER_OPENED_RELATED_TICKET_MODAL: '[Tickets] User clicked: related ticket',
    USER_OPENED_TICKET_DETAILS: '[Tickets] User clicked: tab Details',
    USER_BEGAN_WRITING_SUBJECT: '[Tickets] User began writing subject',
    SUBJECT_PUBLISHED: '[Tickets] Subject was published',
    SEARCH_BEGAN_TYPING: '[Tickets] Search: began typing',
    SEARCH_PERFORMED: '[Tickets] Search: performed',
    SEARCH_LOAD_MORE: '[Tickets] Search: load more scroll bottom',
    GENERATE_TRANSCRIPT: '[Tickets] AI: Generate transcript',
    GENERATE_SUMMARY: '[Tickets] AI: Generate summary',
    TAGS_GENERATE_SUGGESTED: '[Tickets] AI: Generate suggested tags',
    TAGS_SUGGESTED_ADDED: '[Tickets] AI: Added tag to ticket',
    TAGS_SUGGESTED_REMOVED: '[Tickets] AI: Removed tag from ticket',
    CONFIRM_GENERATE_TRANSCRIPT: '[Tickets] AI: Confirm generate transcript',
    WHATSAPP_TEMPLATE_TEXT:
        '[Tickets] WhatsApp: User clicked: Reply with template button',
    WHATSAPP_TEMPLATE_ICON:
        '[Tickets] WhatsApp: User Clicked: templates button',
    CONFIRM_WHATSAPP_TEMPLATE:
        '[Tickets] WhatsApp: confirm send WhatsApp template',
    ASSIGN_TO_SELF_AND_REPLY_INPUT_CLICK:
        '[Tickets] User clicked: assign to self and reply text',
    CLICKED_UNLOCK_TO_REPLY: '[Tickets] User clicked: unlock input field',
    VIEW_TICKET_DETAILS_CLICK:
        '[Tickets] User clicked: view ticket details button',
    VIEW_FULL_TRANSCRIPT_CLICK:
        '[Tickets] User clicked: view full transcript button',
    COPY_TRANSCRIPT_TEXT_CLICK:
        '[Tickets] User clicked: copy text from transcript button',
    DOWNLOAD_CALL_RECORDING_CLICK:
        '[Tickets] User clicked: download call recording button',
    PLAY_CALL_RECORDING_CLICK:
        '[Tickets] User clicked: play call recording button',
    GENERATE_SUMMARY_CLICK: '[Tickets] AI WhatsApp: generate summary button',
    OPEN_GENERATE_SUMMARY_MODAL_CLICK:
        '[Tickets] User clicked: open generate summary modal button',
    POST_INTERNAL_NOTE_CLICK:
        '[Tickets] User clicked: post as internal note button',
    FOCUS_TEXTAREA_EDIT: '[Tickets] User clicked: edit summary text area',
    CLICK_EDIT_SUMMARY_BUTTON:
        '[Tickets] User clicked: edit button to enable editing summary',
    EMOJI_BUTTON_CLICK: '[Tickets] User clicked: emoji button',
    ADD_EMOJI_TO_TEXT_FIELD: '[Tickets] User added emoji to text field',
    START_TEXTAREA_EDIT: '[Tickets] User started editing text field',
    MORE_VERT_CLICK_EVENT_CALL_REORDING: '[Tickets] User clicked: more button',
    MORE_VERT_CLICK_TICKET_LIST_ITEM: '[Tickets] User clicked: more button',
    REMOVE_MEMBER: '[Tickets] User clicked: remove member',
    ADD_MEMBERS: '[Tickets] User clicked: add members',
    CLICK_GO_TO_ADD_MEMBERS_MODAL:
        '[Tickets] User clicked: go to add members modal',
    ADD_MEMBERS_IN_MODAL: '[Tickets] User clicked: select user',
    REMOVE_MEMBER_IN_MODAL: '[Tickets] User clicked: deselect user',
    CLICK_GO_TO_A_RELATED_TICKET: '[Tickets] User clicked: tab Related',
    CLICK_SHOW_TICKET: '[Tickets] User clicked: show ticket',
    CLICK_CREATE_TICKET: '[Tickets] User clicked: create ticket',
    CLICK_CONFIRM_CREATE_TICKET:
        '[Tickets] User clicked: confirm create ticket',
    CLICK_GO_TO_CREATED_TICKET: '[Tickets] User clicked: go to created ticket',
    CLICK_GO_TO_TICKET: '[Tickets] User clicked: go to ticket',
    CLICK_TAB_MY_TICKETS: '[Tickets] User clicked: tab Mine',
    CLICK_TAB_UNASSIGNED: '[Tickets] User clicked: tab Unassigned',
    CLICK_TAB_ALL: '[Tickets] User clicked: tab All',
    CLICK_TAB_FILTER: '[Tickets] User clicked: tab Filter',
    OPENED_CONTACT_MODAL: '[Tickets] User clicked: open contact modal',
    OPENED_CREATE_CONTACT_MODAL:
        '[Tickets] User clicked: open create contact modal',
    CLICK_GO_TO_ADD_MEMBERS: '[Tickets] User clicked: go to members',
    CHANGE_GENERAL_ACCESS: '[Tickets] User changed: general access',
    OPENED_MEMBERS_CONTACT_MODAL:
        '[Tickets] User clicked: open members contact modal',
    OPENED_CREATE_MEMBERS_CONTACT_MODAL:
        '[Tickets] User clicked: open create members contact modal',
    CREATION_MEMBERS_CLICKED_SELF:
        '[Tickets] Creation: User clicked members type: self',
    CREATION_MEMBERS_CLICKED_ALL_QUEUE_MEMBERS:
        '[Tickets] Creation: User clicked members type: all queue members',
};

export const CALL_HISTORY_STRINGS = {
    CLICK_MARK_AS_HANDLED: '[Call history] User clicked: mark as handled',
    CLICK_CONFIRM_MARK_AS_HANDLED:
        '[Call history] User clicked: confirm mark as handled',
    CLICK_UNMARK_AS_HANDLED: '[Call history] User clicked: unmark as handled',
    CLICK_CONFIRM_UNMARK_AS_HANDLED:
        '[Call history] User clicked: confirm unmark as handled',
};

export const TAG_STRINGS = {
    CREATE_ADD_NEW_TAG: '[Tags] Created + added new tag to ticket',
    ADD_EXISTING_TAG: '[Tags] Added tag to ticket',
    REMOVE: '[Tags] Removed tag from ticket',
};

export const CONFERENCE_LOCATIONS = {
    AUTO_JOIN: 'auto_join',
    LOBBY: 'lobby',
    CONFERENCE_ROOM: 'conference_room',
};
